import { QueryClient } from 'react-query';

export async function ensureQuery<T>(
  queryClient: QueryClient,
  query: { queryKey: string[]; queryFn: () => Promise<T> }
): Promise<T> {
  return queryClient.getQueryData(query.queryKey) ?? (await queryClient.fetchQuery(query));
}
